import { Employee } from '../../../../domain/employees/employee';
import RoleSelector from '../../../roles/components/roleSelector';
import HasUserSelector from '../../../user/components/HasUserSelector';

interface Props {
    employee: Employee;
    onChange: (name: string, value: string | number | undefined | boolean) => void;
}

export default function OtherInformationSection({
    employee,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='my-3'>Información Adicional</h5>
            <div className='col-6'>
                <RoleSelector
                    name='role'
                    onChange={handleInputChange}
                    value={employee.role}
                    disabled={!employee.hasUser}
                />
            </div>
            <div className='col-6'>
                <HasUserSelector
                    label='Es Usuario? *'
                    name='hasUser'
                    onChange={handleInputChange}
                    value={employee.hasUser}
                />
            </div>
        </>
    );
}
